<div class="simple-dialog-container" *ngIf="data">
  <!-- Loading state -->
  <ng-container *ngIf="isLoading">
    <div class="loading-container">
      <p-progressSpinner
        [style]="{ width: '50px', height: '50px' }"
        strokeWidth="4"
        animationDuration="1.65s"
      ></p-progressSpinner>
      <span class="loading-text">{{
        data.loadingMessage || 'Procesando...'
      }}</span>
    </div>
  </ng-container>

  <!-- Normal state -->
  <ng-container *ngIf="!isLoading">
    <i
      *ngIf="!!!data?.hideCloseIcon"
      (click)="closeDialog()"
      class="pi pi-times close-icon"
    ></i>
    <h2 class="dialog-title">{{ data.title }}</h2>
    <div class="dialog-message">
      <ng-container *ngIf="!data.boldText">{{ data.message }}</ng-container>
      <ng-container *ngIf="data.boldText">
        {{ messageParts.before }}<strong>{{ messageParts.bold }}</strong
        >{{ messageParts.after }}
      </ng-container>
    </div>

    <!-- Actions -->
    <div class="dialog-actions">
      <button (click)="onConfirmClick()" class="button button-delete">
        <i class="pi pi-trash"></i>
        Eliminar
      </button>
    </div>
  </ng-container>
</div>
